import React from "react";
import styled from "styled-components";
import { Skeleton } from "components/ui/Skeleton";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e3e7ef;
  width: calc(100% - 32px);
  margin: 0 auto;
`;

const InnerBox = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #f9fafb;
  border-radius: 16px;
`;

const FullSkeleton = styled(Skeleton)`
  height: 24px;
  width: 100%;
`;

export const SalesDashboardAverageSummarySkeleton = () => {
  return (
    <Wrapper>
      <InnerBox>
        <FullSkeleton />
        <FullSkeleton />
        <FullSkeleton />
      </InnerBox>
    </Wrapper>
  );
};
